import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "empty-state"
}

import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonItem, IonLabel, IonRadio, IonRadioGroup, IonTitle, IonToolbar, modalController } from "@ionic/vue";
import { closeOutline, saveOutline } from "ionicons/icons";
import { translate } from '@hotwax/dxp-components';
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import { hasError, showToast } from "@/utils";
import { ChannelService } from '@/services/ChannelService';
import logger from "@/logger";
import { DateTime } from "luxon";
import emitter from "@/event-bus";


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkThresholdFacilitiesToGroupModal',
  props: ["group", "selectedConfigFacilityId"],
  setup(__props) {

const store = useStore();
const selectedFacilityId = ref("");
const props = __props;

const configFacilities = computed(() => store.getters["util/getConfigFacilities"])

onMounted(() => {
  selectedFacilityId.value = props.selectedConfigFacilityId?.facilityId ? JSON.parse(JSON.stringify(props.selectedConfigFacilityId.facilityId)) : '';
})

function closeModal() {
  modalController.dismiss({ dismissed: true });
}

async function saveFacility() {
  if(!selectedFacilityId.value) {
    showToast(translate("Please select a facility to update."))
    return;
  }
  let resp = {} as any;
  
  emitter.emit("presentLoader");

  try {
    if(props.selectedConfigFacilityId?.facilityId) {
      resp = await ChannelService.updateFacilityAssociationWithGroup({
        facilityGroupId: props.group.facilityGroupId,
        facilityId: props.selectedConfigFacilityId.facilityId,
        fromDate: props.selectedConfigFacilityId.fromDate,
        thruDate: DateTime.now().toMillis()
      });
      if(hasError(resp)) {
        throw resp.data;
      }
    }

    resp = await ChannelService.updateFacilityAssociationWithGroup({
      facilityGroupId: props.group.facilityGroupId,
      facilityId: selectedFacilityId.value,
      fromDate: DateTime.now().toMillis()
    });
    if(!hasError(resp)) {
      showToast(translate("Threshold facility updated successfully."))
      modalController.dismiss();
    } else {
      throw resp.data;
    }
  } catch(err: any) {
    logger.error(err)
    showToast(translate("Failed to update threshold facility."))
  }
  await store.dispatch("channel/fetchGroupFacilities", props.group.facilityGroupId);
  emitter.emit("dismissLoader");
}

function isFacilityUpdated() {
  return props.selectedConfigFacilityId?.facilityId !== selectedFacilityId.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Link threshold")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        (configFacilities.value.length)
          ? (_openBlock(), _createBlock(_unref(IonRadioGroup), {
              key: 0,
              modelValue: selectedFacilityId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFacilityId).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configFacilities.value, (facility) => {
                  return (_openBlock(), _createBlock(_unref(IonItem), {
                    key: facility.facilityId
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRadio), {
                        value: facility.facilityId
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(facility.facilityName) + " ", 1),
                              _createElementVNode("p", null, _toDisplayString(facility.facilityId), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", null, _toDisplayString(_unref(translate)("No facility found.")), 1)
            ])),
        _createVNode(_unref(IonFab), {
          vertical: "bottom",
          horizontal: "end",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), {
              disabled: !isFacilityUpdated(),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (saveFacility()))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})